import useAuth from './useAuth';

export default function useUserId(): string | null {
  const { userInfo } = useAuth();
  return userInfo?.userId ?? null;
}
